import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const TaskStatusIcon = ({ status, isBlocked, inapplicable, rejected, className, onClick, small }) =>
  typeof status !== 'undefined' && (
    <i
      className={classNames(className, {
        fa: true,
        'fa-lg': !small,
        'fa-circle': !isBlocked && !inapplicable && !rejected,
        'fa-minus-circle text-danger': isBlocked,
        'greyed-out': status === 0 && !isBlocked,
        orange: status === 1 && !isBlocked && !inapplicable && !rejected,
        green: status === 2 && !isBlocked && !inapplicable && !rejected,
        'fa-times-circle ': inapplicable,
        'fa-ban': rejected,
        clickable: onClick !== null,
      })}
      {...(onClick !== null ? { onClick } : {})}
    />
  );
TaskStatusIcon.propTypes = {
  status: PropTypes.oneOf([undefined, 0, 1, 2]),
  isBlocked: PropTypes.bool,
  inapplicable: PropTypes.bool,
  rejected: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func,
  small: PropTypes.bool,
};

TaskStatusIcon.defaultProps = {
  status: undefined,
  isBlocked: false,
  inapplicable: false,
  rejected: false,
  className: null,
  onClick: null,
  small: false,
};
export default TaskStatusIcon;
